(function () {
    'use strict';
    angular
      .module('atcCallSign', [
        'ui.router'
      ]);
  }());
